export default __webpack_public_path__ + "static/media/samsung.603a6252.png";